module.exports = __webpack_public_path__ + "img/lb2_h5.5b72f51d.png";